import { FILE_TYPE_NAME_BY_MIME } from 'constants/file.constants'
import { KEYCLOAK_STORAGE_ACCESS_TOKEN } from '../constants/keycloakConstants'
import { errorToast } from '../utils/toast'
import { redirectToLogout } from './keycloakService'

const getDefaultHeaders = (headersOverride, isOnlyFile) => {
  const token = localStorage.getItem(KEYCLOAK_STORAGE_ACCESS_TOKEN)

  const headers = {
    ...(isOnlyFile ? {} : { 'Content-Type': 'application/json' }),
    ...headersOverride,
    ...(token && { Authorization: `Bearer ${token}` }),
  }

  return Object.fromEntries(Object.entries(headers).filter(([_, value]) => value !== undefined))
}

/**
 * Permet de transformer les données d'un objet en format url
 * @param filters
 * @returns {string}
 */
export function filtersToUrlParams(filters) {
  return Object.entries(filters)
    .map((filter) => filter.join('='))
    .join('&')
}

/**
 * Fonction générique qui envoie les requêtes à l'API
 * @param {*} endpoint
 * @param {*} method
 * @param {*} body
 * @param {*} headers
 * @param {*} isOnlyFile isOnlyFile Indique si la requête contient uniquement un fichier, afin d’éviter l’envoi de données au format JSON.
 */
const callApi = async (endpoint, method, body, headers = {}, isOnlyFile = false) => {
  return fetch(`/api/${endpoint}`, {
    method,
    headers: getDefaultHeaders(headers, isOnlyFile),
    body,
  })
    .then(async (res) => {
      if (res.status === 204) {
        return null
      }

      if (res.status === 401 && endpoint === '/auth/login_callback') {
        return Promise.reject(res)
      }

      if (res.status === 401) {
        redirectToLogout(false, window.location.pathname)
        return null
      }

      if (res.status === 201) {
        return Promise.resolve(res)
      }

      if (res.status === 403) {
        errorToast("Vous n'avez pas les droits pour effectuer cette action")
        return Promise.reject(res)
      }
      // si c'est un fichier on retourne directement la réponse
      const contentType = res.headers.get('content-type')
      if (contentType && Object.keys(FILE_TYPE_NAME_BY_MIME).some((disposition) => contentType.includes(disposition))) {
        return res
      }

      return res.json().then((response) => {
        if (!res.ok) {
          return Promise.reject(response)
        }
        return response
      })
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}
export default callApi
